// =============================================================================
// PG LIVE管理画面
// =============================================================================

function PG_start_live_admin(pg_chat_origin, customer_id) {
  $("#shopify-section-header").hide();
  $("#shopify-section-footer").hide();
  $(".dissmiss_for_refund").hide();
  $(".main-content").css("padding-top", "0px");

  let video_key = getParam('video_key');
  let chat_key = getParam('chat_key');
  let title = getParam('title');
  let order_key = getParam('order_key');
  let questionnaire_key = getParam('questionnaire_key');

  if (video_key.includes('vm:')) {
    $('#vimeo_iframe_admin').attr('src', 'https://player.vimeo.com/video/' + video_key.slice(3));
    const PG_player = new Vimeo.Player($('#vimeo_iframe_admin'));

    PG_player.on('loaded', function() {
      PG_player.play();
    });

  } else if (video_key.includes('sv:')) {
    $('#live_streaming_admin').before(`<script src=""></script>`);
    $('#PG_video_screen_admin').html(`<div class="sv-embed live-streaming-screen" data-cid="${video_key.slice(3)}" data-playwithfullscreen="false"></div>`);

  } else if (video_key.includes('sv_live:')) {
    $('#live_streaming_admin').before(`<script src=""></script>`);
    $('#PG_video_screen_admin').html(`<div class="swipevideo live-streaming-screen" data-src="${video_key.slice(8)}" data-playwithfullscreen="false"></div>`);
  }

  if (questionnaire_key) {
    $("#admin_questionnaire_tab").show();
    $("#questionnaire_note_admin").show();
  }

  let order_url = `/account/orders/${order_key}`;
  let questionnaire_url = `https://enquete.eventos.tokyo/admin/questionControl/?key=${questionnaire_key}`;

  $("#live_streaming_title_admin").text(title);
  $("#order_link_admin").attr('href', order_url);
  show_or_hide_admin_chat(chat_key, pg_chat_origin, customer_id);
  $("#questionnaire_iframe_admin").attr('src', questionnaire_url);
  $("#questionnaire_disable_link").attr('href', questionnaire_url);

  window.addEventListener(
    'message',
    (event) => {
      if (event.origin === pg_chat_origin && typeof event.data === 'object' && 'can_use_session_storage' in event.data && !event.data.can_use_session_storage) {
        // アンケートが使えない場合の処理
        $("#questionnaire_iframe_admin").hide();
        $("#questionnaire_disable_admin").show();
      }
    },
    false
  );

  // NOTE: タブメニュー切り替えのロジック
  $('.live-streaming-tab').click(function() {
    $('.is-active').removeClass('is-active');
    $(this).addClass('is-active');
    $('.is-show').removeClass('is-show');
    let id = $(this).attr('id');
    let admin_chat_iframe = document.getElementById('chat_iframe_admin').contentWindow;
    switch(id) {
      case 'admin_comment_tab':
        $('#chat_content_admin').addClass('is-show');
        admin_chat_iframe.postMessage('admin_comment', pg_chat_origin);
        break;
      case 'admin_chat_tab':
        $('#chat_content_admin').addClass('is-show');
        admin_chat_iframe.postMessage('chat', pg_chat_origin);
        break;
      case 'admin_questionnaire_tab':
        $('#questionnaire_content_admin').addClass('is-show');
        break;
    }
  });
}

function show_or_hide_admin_chat(chat_key, pg_chat_origin, customer_id) {
  if (chat_key === "?" || chat_key === "？") {
    $("#chat_iframe_admin").remove();
  } else {
    $("#chat_iframe_admin").attr('src', `${pg_chat_origin}/admin-chat/${chat_key}?user_id=${customer_id}&t=${getParam('t')}`);
  }
}
